// extracted by mini-css-extract-plugin
export default {"tasks":"qO-z","task":"rO-z","svg":"sO-z","text":"tO-z"};